// Turns a stored session (platform + userAgent + optional mobile deviceLabel)
// into the kind of label every "Active Sessions" screen shows industry-wide —
// "Chrome on Windows", "Safari on iPhone", "iPhone 15 Pro" — instead of the
// generic "Web browser" / "My Waypoint app" placeholder. No UA-parsing
// library is pulled in for this; browser/OS detection from a User-Agent
// string only needs a handful of ordered substring checks.
const detectBrowser = (ua) => {
  if (!ua) return null;
  if (/EdgA?\//.test(ua)) return "Edge";
  if (/OPR\/|Opera/.test(ua)) return "Opera";
  if (/CriOS/.test(ua)) return "Chrome";
  if (/FxiOS/.test(ua)) return "Firefox";
  if (/Firefox\//.test(ua)) return "Firefox";
  // Chrome's UA also contains "Safari/", so Chrome/Edge/Opera must all be
  // checked first — real Safari is whatever's left with Safari but no Chrome.
  if (/Chrome\//.test(ua)) return "Chrome";
  if (/Safari\//.test(ua) && /Version\//.test(ua)) return "Safari";
  return null;
};

const detectOs = (ua) => {
  if (!ua) return null;
  if (/iPhone/.test(ua)) return "iPhone";
  if (/iPad/.test(ua)) return "iPad";
  if (/Android/.test(ua)) return "Android";
  if (/Mac OS X/.test(ua)) return "Mac";
  if (/Windows/.test(ua)) return "Windows";
  if (/CrOS/.test(ua)) return "Chromebook";
  if (/Linux/.test(ua)) return "Linux";
  return null;
};

// `session` is whatever userSessionService.getMySessions() returns per
// entry: { platform, userAgent, deviceLabel }.
export function getSessionLabel(session) {
  if (!session) return "Unknown device";

  if (session.platform === "mobile") {
    // expo-device's Device.modelName — the real marketing name ("iPhone 15
    // Pro", "Redmi Note 12", "Infinix Hot 30") — set only by requests the
    // mobile app itself made (see mobile/src/store/apiClient.js). Sessions
    // created before that shipped, or from a device expo-device couldn't
    // identify, fall back to a generic app label.
    return session.deviceLabel || "My Waypoint app";
  }

  const browser = detectBrowser(session.userAgent);
  const os = detectOs(session.userAgent);
  if (browser && os) return `${browser} on ${os}`;
  if (browser) return browser;
  if (os) return `Web browser on ${os}`;
  return "Web browser";
}
